import axios from "axios";
import React, { useEffect, useState } from "react";
import { API, api_url, generateAuthHeader } from "../../util/util";
import SemiCircleProgressBar from "react-progressbar-semicircle";

function Score() {
  const [score, setScore] = useState(null);
  const [count, setCount] = useState(0);

  const effectivenessLabels = [
    { threshold: 100, label: "Optimal" },
    { threshold: 85, label: "Strong" },
    { threshold: 60, label: "Solid" },
    { threshold: 40, label: "Consider" },
    { threshold: 15, label: "Questionable" },
    { threshold: 0, label: "Avoid" },
  ];

  const getEffectivenessLabel = (score) => {
    const label = effectivenessLabels.find((item) => score >= item.threshold);
    return label ? label.label : "Unknown";
  };

  const handleScoreData = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get("query");
    const url = `${api_url}/${API.ENDPOINTS.score}?permalink=${query}`;
    console.log("url", url);
    try {
      const response = await axios.get(url, {
        headers: {
          "Authorization ": generateAuthHeader(),
        },
      });

      if (response.status === 200) {
        setScore(response.data.score);
        setCount((prevCount) => prevCount + 1);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleScoreData();
    }, 3000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="score-container">
      <div className="score-content">
        <SemiCircleProgressBar
          percentage={score}
          showPercentValue
          background="#ECECEC"
          stroke="#A686FF"
        />
        <div className="score-text">
          <p className="company-score me-3">COMPANY SCORE</p>
          <span className="effectiveness justify-content-center d-flex">
            {score !== null ? getEffectivenessLabel(score) : "Loading..."}
          </span>
        </div>
        <a href="#" className="calculation-link">
          How is this calculated?
        </a>
      </div>
    </div>
  );
}

export default Score;
